// removed by extract-text-webpack-plugin
module.exports = {"root":"root__1IJOKo5WXVjo","scrollableList":"scrollableList__3lTamYBAg5Lq","returnIcon":"returnIcon__12WOtyDdXUJB"};